/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Note } from './Note';
import {
    NoteFromJSON,
    NoteFromJSONTyped,
    NoteToJSON,
    NoteToJSONTyped,
} from './Note';

/**
 * 
 * @export
 * @interface PaginatedNoteList
 */
export interface PaginatedNoteList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedNoteList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNoteList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNoteList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Note>}
     * @memberof PaginatedNoteList
     */
    results: Array<Note>;
}

/**
 * Check if a given object implements the PaginatedNoteList interface.
 */
export function instanceOfPaginatedNoteList(value: object): value is PaginatedNoteList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedNoteListFromJSON(json: any): PaginatedNoteList {
    return PaginatedNoteListFromJSONTyped(json, false);
}

export function PaginatedNoteListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedNoteList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(NoteFromJSON)),
    };
}

  export function PaginatedNoteListToJSON(json: any): PaginatedNoteList {
      return PaginatedNoteListToJSONTyped(json, false);
  }

  export function PaginatedNoteListToJSONTyped(value?: PaginatedNoteList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(NoteToJSON)),
    };
}

